import listView from "./listView.component";

const listViewModule = angular
  .module("app.components.listView", [])
  .component("listView", listView);

export default listViewModule;



// WEBPACK FOOTER //
// ./src/components/listView/listView.module.js